import React from 'react';
import { FormattedMessage } from 'react-intl';
// Components
import GeneralProgrammingContainer from '../../../containers/GeneralProgrammingContainer';
import DateContainer from '../../../containers/DateContainer';

const GeneralProgramming = (props) => {
  return (
    <div className="ui grid">
      <div className="row">
        <div className="column">
          <h2 className="ui header">
            <FormattedMessage
              id="generalProgramming"
              description="General Programming menu item"
            />
          </h2>
        </div>
      </div>
      <div className="row">
        <div className="column">
          <div className="ui container">
            <DateContainer />
            <GeneralProgrammingContainer {...props} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default GeneralProgramming;



/** WEBPACK FOOTER **
 ** ./src/components/screens/generalProgramming/GeneralProgramming.js
 **/